import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Group} from "../../../../types/interfaces";
import {TelegramComponent} from "../../modals/chose-group/telegram/telegram.component";
import {ModalController, Platform} from "@ionic/angular";
import {PaymentComponent} from "../../modals/payment/payment.component";
import {AGREEMENT_LINK} from "../../../constants";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {ParentService} from "../../../../services/mygreencountry/parent.service";
import {PaymentApiResponse} from "../../../../types/apiResponse.interface";

@Component({
    selector: 'app-reserved',
    templateUrl: './reserved.component.html',
    styleUrls: ['./reserved.component.scss'],
})
export class ReservedComponent implements OnInit {

    @Input() group: Group | null = null;
    isAndroid: boolean = false;
    alreadyDownloadedLinks: boolean = false;
    public hasPaid: boolean | undefined = undefined;
    public hasEmptySeats: boolean | undefined = undefined;
    public showDetails: boolean = false;
    activeChild$ = this.parentService.getActiveChild();

    public paymentLinks: PaymentApiResponse;

    @ViewChild('popover') popover: any;

    isOpen = false;
    protected readonly AGREEMENT_LINK = AGREEMENT_LINK;

    constructor(private modalCtrl: ModalController, public myGcService: MyGreenCountry, private platform: Platform,
                private preloaderService: PreloaderService,
                private parentService: ParentService,) {

        this.isAndroid = this.platform.is('android');
    }

    ngOnInit() {
        this.hasPaid = !this.group?.debts?.debt_amount
        this.hasEmptySeats = this.group?.hasEmptySeats
    }

    presentPopover(e: Event) {
        this.popover.event = e;
        this.isOpen = true;
    }

    goToPay() {
        if (!this.alreadyDownloadedLinks) {
            this.getPaymentUrl().then(r => {
                this.checkModal();


            })
        } else {
            this.checkModal();
        }

    }

    checkModal() {
        if (this.paymentLinks) {
            if (this.paymentLinks.web != null) {
                this.showPaymentModal()
            } else {
                this.myGcService.openUrl(this.paymentLinks.android)
            }
        }
    }

    async getPaymentUrl() {
        let child = this.activeChild$.value

        if (child) {
            let phone = child.phone;

            await this.preloaderService.showLoading("Зачекайте, будь ласка ");

            this.parentService
                .getPaymentLink(phone, this.isAndroid)
                .subscribe({

                    next: (response: PaymentApiResponse) => {
                        this.paymentLinks = response;
                        if (this.paymentLinks) {
                            this.alreadyDownloadedLinks = true;
                        }
                    },

                    error: (errorResponse: any) => {

                    },

                    complete: () => {

                        this.preloaderService.hideLoading();

                    }

                })

            await this.preloaderService.hideLoading();
        }
    }

    async showPaymentModal() {
        const modal = await this.modalCtrl.create({
            component: PaymentComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                androidLink: this.paymentLinks.android,
                webLink: this.paymentLinks.web
            }

        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

    openUrl(url: string) {
        this.myGcService.openUrl(url)
    }
}
